module.exports = __webpack_public_path__ + "img/openClient.887fe107.png";